import PerformanceReportChart from "./PerformanceReportChart";
// import CostsChart from "./CostsChart";
import Queries from "../../queries/queries2";
import React from "react";
import ReportingContainer from "../Reporting/ReportingContainer";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

class PerformanceReportContainer extends ReportingContainer {
  render() {
    return (
      <ReportingContainer
        {...this.props}
        type={"PERFORMANCE"}
        // header={"ids_performance"}
        header={"ids_reports"}
        query={Queries.getReportSalesData}
        Chart={PerformanceReportChart}
        showChart={false}
        showData={true}
        showPeriodSelect={false}
        showRangeSelect={false}
        showBudgetComparator={true}
        hideBudgetTypeSelect={true}
        hideReportsTypeSelect={false}
      />
    );
  }
}

export default withRouter(injectIntl(PerformanceReportContainer));
